import vIcon from '@/components/form/v-icon';
import utils from '../utils';

/**
* Creates a component that creates an external link.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @returns {Array}
 */
export default function externalColumn({cachedColumn, rowData, createElement}) {
    const values = utils.getCellValues({cachedColumn, rowData});
    let children;
    if (values.length) {
        children = [values.join('')];
        children.push(createElement(
            'a',
            {
                attrs: {
                    target: '_blank',
                    href: values.join(''),
                },
            },
            [
                createElement(
                    vIcon,
                    {
                        props: {
                            icon: 'external-link',
                        },
                    },
                ),
            ],
        ));
    } else {
        children = [utils.getEmptyCellElement(createElement)];
    }
    return [
        'div',
        {
            attrs: {title: values.join('')},
            class: 'is-external',
        },
        children,
    ];
}
